import React, { FC } from 'react';

import { getDurationFromTime, getLogoUrl, getDaysDifference } from 'utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { getElapsedStr } from 'utils/dynamic/dynamic';
import { GdsFlyAir, HighlightRoute, Outbound } from 'ts/dynamic/interfaces/DynamicResponse';
import TicketRouteTime from './TicketRouteTime';
import TickteBaggage from './TicketBaggage';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { blobUrl } from 'constants/generic';

interface TicketRouteGdsProps {
  outbond: Outbound;
  gdsIndex: number;
  highlighted?: HighlightRoute;
}

const TicketRouteGds: FC<TicketRouteGdsProps> = ({ outbond, gdsIndex, highlighted }) => {
  const [t] = useTranslation();
  

  const gdsFlyAir: GdsFlyAir = outbond.gdsFlyAirs[gdsIndex];
  const arrivalDaysDifference = getDaysDifference(
    gdsFlyAir.departureDateTime,
    gdsFlyAir.arrivalDateTime
  );

  return (
    <div className="ticket-segment">
      <div className="ticket-route">
        <span className="ticket-airline">
          <img src={getLogoUrl(blobUrl, gdsFlyAir.airline.code)} alt={gdsFlyAir.airline.desc} />
        </span>
        <div className="ticket-data">
          <TicketRouteTime
            dateTime={gdsFlyAir.departureDateTime}
            airportDesc={gdsFlyAir.departureAirport.desc}
            airport={gdsFlyAir.departureAirport.code}
            highlighted={highlighted?.departure}
          />
          <div className="ticket-directions">
            <span className="stops-duration">{getElapsedStr(gdsFlyAir.elapsedDTime)}</span>
            <span className="line">
              <FontAwesomeIcon icon={faPlane} />
            </span>
          </div>
          <TicketRouteTime
            dateTime={gdsFlyAir.arrivalDateTime}
            airportDesc={gdsFlyAir.arrivalAirport.desc}
            airport={gdsFlyAir.arrivalAirport.code}
            arrivalDaysDifference={arrivalDaysDifference}
            highlighted={highlighted?.arrival}
          />
        </div>

        <TickteBaggage bound={outbond} />
      </div>
      {outbond.gdsFlyAirs[gdsIndex].stopDuration !== '0' && (
        <div className="ticket-gds-stop">
          <span>
            {t('filter.stop_up')} {t('at')}{' '}
          </span>
          <span>{outbond.gdsFlyAirs[gdsIndex].arrivalAirport.cityDesc}</span>
          <br />
          <span>{getDurationFromTime(parseInt(outbond.gdsFlyAirs[gdsIndex].stopDuration))}</span>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(TicketRouteGds, 'TicketRouteGds');
